import { createNode } from '@glueapp/graph-types';
import { deepEqual } from '../../utils/deepEqual';

export const UnEqual = createNode({
    id: 'UnEqual (!=)',
    name: 'UnEqual (!=)',
    description: 'Returns true if the two inputs are not equal. Uses deep comparison for objects and arrays.',
    aiDescription:
        'Checks if two values are not equal using deep comparison. Connect values to "First" and "Second" input ports (generic, same type); the "Output" port returns a boolean.',
    category: 'Comparison',
    color: '#46aa43',
    integration: undefined,
    inPorts: {
        First: { kind: 'generic', identifier: 'T' },
        Second: { kind: 'generic', identifier: 'T' },
    },
    outPorts: {
        Output: { kind: 'boolean' },
    },
    execute: function (input) {
        const first = input.inPorts.First;
        const second = input.inPorts.Second;
        const isEqual = first === second || deepEqual(first, second);
        return { output: { Output: !isEqual } };
    },
});
